// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__1OB-R","choiceBoxes":"toolbarselects_choiceBoxes__3SnSj","simpleField":"toolbarselects_simpleField__1sjI9"};